import { render, staticRenderFns } from "./index.m.vue?vue&type=template&id=bc2c0a10&scoped=true"
import script from "./index.m.vue?vue&type=script&lang=js"
export * from "./index.m.vue?vue&type=script&lang=js"
import style0 from "./index.m.vue?vue&type=style&index=0&id=bc2c0a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2c0a10",
  null
  
)

export default component.exports